import { Extra } from "./Extra";

export type BookTrip = {
  slotId: string;
  departureOriginTime: string;
  departureDestinationTime: string;
  numberOfAdults: number;
  numberOfChildren: number;
  email: string;
  fullName: string;
  phone: string;
  addressLine: string;
  postCode: string;
  country: string;
  language: string;
  applyResidentsDiscount: boolean;
  voucherCode?: string;
  source: string;
  extras: Extra[];
  ignoreDiscounts: boolean;
  sourceUrl?: string;
};

export const defaultBookTrip: BookTrip = {
  slotId: "",
  numberOfAdults: 0,
  numberOfChildren: 0,
  departureOriginTime: "",
  departureDestinationTime: "",
  email: "",
  fullName: "",
  phone: "",
  addressLine: "",
  postCode: "",
  country: "",
  applyResidentsDiscount: false,
  voucherCode: undefined,
  language: "",
  source: "",
  extras: [],
  ignoreDiscounts: false,
  sourceUrl: "https://booking.lanchaslagaviota.com/booking-completed",
};
